/// <reference types="@lib/types" />
export function isOptionSetDisabled(optionSet) {
    return optionSet.disabled === true || optionSet._internal?.disabled === true;
}
export function isOptionSetAvailableForOrdering(optionSet) {
    return !isOptionSetDisabled(optionSet);
}
export function buildOptionSetAttachUpdates(menus, optionSetIds, dishIds) {
    const targetDishIds = new Set(dishIds);
    const selectedOptionSetIds = optionSetIds.filter(Boolean);
    const updates = [];
    for (const menu of menus || []) {
        for (const category of menu.categories || []) {
            for (const dish of category.dishes || []) {
                if (!targetDishIds.has(dish._id))
                    continue;
                const currentOptionSets = [...(dish.option_sets || [])];
                const nextOptionSets = [...currentOptionSets];
                for (const optionSetId of selectedOptionSetIds) {
                    if (!nextOptionSets.includes(optionSetId))
                        nextOptionSets.push(optionSetId);
                }
                if (nextOptionSets.length === currentOptionSets.length)
                    continue;
                updates.push({
                    menu_id: menu._id,
                    category_id: category._id,
                    id: dish._id,
                    option_sets: nextOptionSets,
                });
            }
        }
    }
    return updates;
}
export function getDishIdsWithOptionSets(menus, optionSetIds) {
    const selectedOptionSetIds = new Set(optionSetIds.filter(Boolean));
    const dishIds = [];
    for (const menu of menus || []) {
        for (const category of menu.categories || []) {
            for (const dish of category.dishes || []) {
                if ((dish.option_sets || []).some((id) => selectedOptionSetIds.has(id))) {
                    dishIds.push(dish._id);
                }
            }
        }
    }
    return dishIds;
}
export function buildOptionSetDetachUpdates(menus, optionSetIds, dishIds) {
    const targetDishIds = new Set(dishIds);
    const selectedOptionSetIds = new Set(optionSetIds);
    const updates = [];
    for (const menu of menus || []) {
        for (const category of menu.categories || []) {
            for (const dish of category.dishes || []) {
                if (!targetDishIds.has(dish._id))
                    continue;
                const currentOptionSets = [...(dish.option_sets || [])];
                const nextOptionSets = currentOptionSets.filter((id) => !selectedOptionSetIds.has(id));
                if (nextOptionSets.length === currentOptionSets.length)
                    continue;
                updates.push({
                    menu_id: menu._id,
                    category_id: category._id,
                    id: dish._id,
                    option_sets: nextOptionSets,
                });
            }
        }
    }
    return updates;
}
export function buildOptionSetDetachAllUpdates(menus, optionSetIds) {
    return buildOptionSetDetachUpdates(menus, optionSetIds, getDishIdsWithOptionSets(menus, optionSetIds));
}
/**
 * Names of restaurant option sets that are disabled ("hidden") but still present on an
 * incoming order (top-level lines and one level of combo choices). The storefront hides
 * them, so a match means a stale client (cart built before the set was hidden). Names come
 * from the restaurant record, never from the payload.
 */
export function findDisabledOptionSetsInOrder(restaurantOptionSets, dishes) {
    const disabledById = new Map();
    for (const optionSet of restaurantOptionSets || []) {
        if (optionSet && isOptionSetDisabled(optionSet)) {
            disabledById.set(optionSet._id, optionSet.name || optionSet._id);
        }
    }
    if (disabledById.size === 0)
        return [];
    const found = new Set();
    const collect = (line) => {
        for (const optionSet of line?.option_sets || []) {
            const id = optionSet?._id;
            if (typeof id === 'string' && disabledById.has(id)) {
                found.add(disabledById.get(id));
            }
        }
    };
    for (const dish of dishes || []) {
        collect(dish);
        for (const choice of dish?.choices || []) {
            collect(choice?.selected);
        }
    }
    return Array.from(found);
}
//# sourceMappingURL=option-sets.js.map